const commonEventsMap = {
};

export default commonEventsMap;



// WEBPACK FOOTER //
// ./src/tracking/commonEventMap.js